
//过滤条件构建器
export function Filter(){
  let TempFun = new function(){};
  TempFun.Filters = Object.assign({},TempFun.Filters);
  TempFun.add = function(keys){
    for(let i=0; i<Object.keys(keys).length;i++){
      if(keys[Object.keys(keys)[i]].length>0){
        TempFun.Filters = Object.assign(TempFun.Filters,keys[i]);
      }
    }
    return TempFun;
  }
  return TempFun;
}

//dbms sql操作 v1.1========================================================================================
//模拟sql操作数据集
export function from(table=null){
  let TempFun = new function(){};
  if(table!=null&&Object.keys(table).indexOf("sdlJsTableDefined")>=0){
    TempFun.jsTable = table;
    TempFun.to = table.vo;
    TempFun.table = table.rows;
  }else{
    TempFun.jsTable = null;
    TempFun.to = {};
    TempFun.table = table;
  }
  TempFun.list = TempFun.table;
  TempFun.where = function (name,op,value,key = ""){
    name = name.trim();
    if(op == undefined){
      const filterKeys = Object.keys(name);
    // name all elements passing the criteria
      TempFun.list = TempFun.list.filter((item) => {
        // dynamically validate all filter criteria
        return filterKeys.every(aKey => {
            //ignore when the filter is empty Anne
          if(!name[aKey].length) return true
          return !!~name[aKey].toString().indexOf(item[aKey])
        })
      })
      return TempFun;
    }
    op = op.trim();
    //等于情况
    if(op == "="){
      if(value==null) return TempFun;
        TempFun.list = TempFun.list.filter(item => item[name] == value);
      return TempFun;
    }
    //不等于情况
    if(op == "<>"||op == "!="){
      if(value==null) return TempFun;
      TempFun.list = TempFun.list.filter(item => item[name] != value);
      return TempFun;
    }
    //在集合情况
    if(op == "in"){
      if(value==null) return TempFun;
      let result = []
        if(key==""){
          TempFun.list.forEach(item => {
            let flag = false;
            //!flag 在这里实现break的作用
            for(let i = 0; !flag && i < value.length; i++) {
              if(item[name] == value[i]) flag = true;
             // console.log(result)
            }
            if(flag) result.push(item);
          });
        }else{
          TempFun.list.forEach(item => {
            let flag = false;
            //!flag 在这里实现break的作用
            for(let i = 0; !flag && i < value.length; i++) {
              if(item[name] == value[i][key]) flag = true;
             // console.log(result)
            }
            if(flag) result.push(item);
          });
        }
      TempFun.list = result;
      return TempFun;
    }
    //不在集合情况
    if(op == "not in"){
      if(value==null || value=="" || value==[]) {
        TempFun.list = TempFun.list;
        return TempFun;
      }
      let result = []
        if(key==""){
          TempFun.list.forEach(item => {
            let flag = false;
            //!flag 在这里实现break的作用
            for(let i = 0; !flag && i < value.length; i++) {
              if(item[name] == value[i]) flag = true;
            }
            if(!flag) result.push(item);
          });
        }else{
          TempFun.list.forEach(item => {
            let flag = false;
            //!flag 在这里实现break的作用
            for(let i = 0; !flag && i < value.length; i++) {
              if(item[name] == value[i][key]) flag = true;
            }
            if(!flag) result.push(item);
          });
        }
      TempFun.list = result;
      return TempFun;
    }
    //模糊检索
    if(op == "like"){
      if(value==null) return TempFun;
      TempFun.list = TempFun.list.filter(item => item[name].toString().indexOf(value)>=0);
      return TempFun;
    }
    if(op == "not like"){
      if(value==null) return TempFun;
      TempFun.list = TempFun.list.filter(item => item[name].toString().indexOf(value)<0);
      return TempFun;
    }
    if(op == ">=" || op == ">"){
      if(value==null) return TempFun;
      TempFun.list = TempFun.list.filter(item => {
        if(isNaN(value)&&!isNaN(Date.parse(value))){//console.log("data是日期格式！")
          let date1 = new Date(item[name].replace(/-/g,"\/"));
          let date2 = new Date(value.replace(/-/g,"\/"));
          if(op.indexOf("=")>=0){
            //console.log(date1 >= date2 ? true:false)
            return date1 >= date2 ? true:false;
          }else{
            return date1 > date2 ? true:false;
          }
        }else{
          if(op.indexOf("=")>=0){
            return item[name] >= value ? true:false;
          }else{
            return item[name] > value ? true:false;
          }
        }
      });
      return TempFun;
    }
    if(op == "<=" || op == "<" ){
      if(value==null) return TempFun;
      TempFun.list = TempFun.list.filter(item => {
        if(isNaN(value)&&!isNaN(Date.parse(value))){//console.log("data是日期格式！")
          let date1 = new Date(item[name].replace(/-/g,"\/"));
          let date2 = new Date(value.replace(/-/g,"\/"));
          if(op.indexOf("=")>=0){
            return date1 <= date2 ? true:false;
          }else{
            return date1 < date2 ? true:false;
          }
        }else{
          if(op.indexOf("=")>=0){
            return item[name] <= value ? true:false;
          }else{
            return item[name] < value ? true:false;
          }
        }
      });
      return TempFun;
    }
    
  }
  //条件或处理
  TempFun.whereOr = function(name1,op1,value1,name2,op2,value2){
    TempFun.list = TempFun.where(name1,op1,value1).list.concat(TempFun.where(name2,op2,value2).list);
    let result = [];
    TempFun.list.forEach(item => {
      if(result.indexOf(item) == -1) result.push(item);
    })
    TempFun.list = result;
    return TempFun
  }
  //取返回数据集，支付3种方式，1：全字段对象集，2：指定字段数组集，3：指定字段首数值集；
  TempFun.select=function(obj=null,type=1){
    if(obj!=null && typeof obj === 'number' && !isNaN(obj) && TempFun.list.length > obj) return TempFun.list[obj];
    let temp =[];
    for(let i=0;i<TempFun.list.length;i++){
      let aObj = Object.assign({},obj);
      let bObj = [];
      for(let j=0;j<Object.keys(aObj).length;j++){
        if(Object.keys(TempFun.list[i]).indexOf(Object.keys(aObj)[j])>=0){
          if(type == 1) aObj[Object.keys(aObj)[j]] = TempFun.list[i][Object.keys(aObj)[j]];
          if(type == 2) bObj.push(TempFun.list[i][Object.keys(aObj)[j]]);
          if(type == 3) bObj = TempFun.list[i][Object.keys(aObj)[j]];
        }
      }
      temp.push(type==1?aObj:bObj);
    }
    if(obj!=null) return temp;
    else return TempFun.list;
  }
  TempFun.objects = 1;
  TempFun.arrays = 2;
  TempFun.values = 3;
  TempFun.pageSize = 20;
  TempFun.pageNum = 1;
  TempFun.pageList = {};
  TempFun.page=function(postData,retObject={}){
    TempFun.pageNum = postData.pageNum==null?TempFun.pageNum:postData.pageNum;
    TempFun.pageSize = postData.pageSize==null?TempFun.pageSize:postData.pageSize; 
    TempFun.pageList = {
      pageNum:TempFun.pageNum,
      pageSize:TempFun.pageSize,
      rows : TempFun.list.slice((TempFun.pageNum-1)*TempFun.pageSize,TempFun.pageNum*TempFun.pageSize),
      total : TempFun.list.length,
    }
  //console.log(response.rows);
  return  Object.assign(TempFun.pageList,retObject);
  }
  //数据删除
  TempFun.delete=function(name=null,op,value,key = ""){
    //console.log("sss");
    if(name!=null){
      let list = TempFun.where(name,op,value,key).select();
      list.forEach(item =>{
        TempFun.list.splice(TempFun.list.indexOf(item),1);
      })
    }else{
      TempFun.list.forEach(item =>{
        TempFun.table.splice(TempFun.table.indexOf(item),1);
      })
    }
    return TempFun; 
  }
  //数据更新
  TempFun.update = function(name,value){
    TempFun.list.forEach(item =>{
      item[name] = value;
    })
    return TempFun; 
  }
  //批量insert
  TempFun.insert = function(list=null){
    if(list==null){
      TempFun.table.push(TempFun.vo);
      TempFun.inserted = TempFun.vo;
      TempFun.vo = {};
      
    }else{
      //判断是对象，还是数组
      list.forEach(item => {
        TempFun.table.push(item);
      })
    }
    return TempFun;
  }
  //数据设值
  TempFun.new = function(){
    TempFun.vo =  Object.assign({},TempFun.to);
    return TempFun; 
  }
  //数据设值
  TempFun.set = function(obj,value=null){
    obj = obj.trim()
    if(value!=null){
      TempFun.vo[obj] = value;
    }else{
      for(let i=0;i<Object.keys(obj).length;i++){
        if(Object.keys(TempFun.vo).indexOf(Object.keys(obj)[i])>=0){
          TempFun.vo[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
        }
      }
    }
    return TempFun; 
  }

  //按键值作去重操作
  TempFun.distinct = function(key=null) {
    let arr = TempFun.select();
    const res = new Map();
    if(key == null) {
      TempFun.list =  arr.filter((item) => !res.has(item) && res.set(item, 1));
    }else{
      TempFun.list = arr.filter((item) => !res.has(item[key]) && res.set(item[key], 1));
    }
    return TempFun; 
   }
  return TempFun; 
}

//dbms工具函数===========================================================================================
export function createTable(vo,head,initNo){
  var table = {
      sdlJsTableDefined:"sdlDefined",
      vo:vo,
      rows:[],
      head:head,
      initNo:initNo,
      newId:function(){
          table.initNo = table.initNo + 1;
          return table.head + table.initNo
      }
  }
  return table;
}

export function dateChange(num = 1,date = false) {
  　　if (!date) {
  　　　　date = new Date();//没有传入值时,默认是当前日期
  　　　　date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  　　}
  　　date += " 00:00:00";//设置为当天凌晨12点
  　　date = Date.parse(new Date(date))/1000;//转换为时间戳
  　　date += (86400) * num;//修改后的时间戳
  　　var newDate = new Date(parseInt(date) * 1000);//转换为时间
  　　return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
}

//======================================================================================================


//单字段单值筛选, 如输入list,"name","Leila" 期望输出为 [{name:'Leila', age: 16, gender:'female'}]
export function Listfilter_1Value(list,name,value) {
  return list.filter(item => item[name] == value)
}

export function Listfilter_1Value_not(list,name,value) {
  return list.filter(item => item[name] != value)
}

//单字段多值筛选，如输入list,"name",['Anne','Jay'],期望输出为 [{name:'Anne', age: 23, gender:'female'},{name:'Jay', age: 19, gender:'male'}]
export function Listfilter_nValue(list,name,values) {
  let result = []
  for(let i = 0; i < values.length; i++) {
    let obj = list.filter(item => item[name] == values[i]);
    console.log(obj);
    //if(obj!=undefined ) result.push(obj);
    if(obj.length > 0){
      for(let j = 0; j < obj.length; j++){
        result.push(obj[j]);
      }
    }
    
  }
  return result
}

//单字段多值筛选，如输入list,"name",['Anne','Jay'],期望输出为 [{name:'Anne', age: 23, gender:'female'},{name:'Jay', age: 19, gender:'male'}]
export function Listfilter_nValue_Not(list,name,values) {
  let result = []
  list.forEach(item => {
    let flag = false;
    for(let i = 0; i < values.length; i++) {
      item[name] == values[i];
      flag = true;
    }
    if(!flag) result.push(item);
  });
  return result
}

export function Listfilter_nValueList(list,name,values,valueName) {
  let result = []
  list.forEach(item => {
    let flag = false;
    //!flag 在这里实现break的作用
    for(let i = 0; !flag && i < values.length; i++) {
      if(item[name] == values[i][valueName]) flag = true;
    }
    if(flag) result.push(item);
  });
  return result
}

export function Listfilter_nValueList_Not(list,name,values,valueName) {
  let result = []
  list.forEach(item => {
    let flag = false;
    //!flag 在这里实现break的作用
    for(let i = 0; !flag && i < values.length; i++) {
      if(item[name] == values[i][valueName]) flag = true;
    }
    if(!flag) result.push(item);
  });
  return result
}


//双字段单值或筛选,如输入list,"name","Anne" ,"age","19" 期望输出为 [{name:'Anne', age: 23, gender:'female'},{name:'Jay', age: 19, gender:'male'}]
export function Listfilter_2Condi_Or(list, name1, value1, name2, value2) {
  return list.filter(item => item[name1] == value1 || item[name2] == value2)
}

export function Listfilter_2Condi_Or_Not(list, name1, value1, name2, value2) {
  return list.filter(item => item[name1] != value1 && item[name2] != value2)
}

//双字段单值与筛选,如输入list,"name","Anne" ,"age","23" 期望输出为 [{name:'Anne', age: 23, gender:'female'}]
export function Listfilter_2Condi_And(list, name1, value1, name2, value2) {
  return list.filter(item => item[name1] == value1 && item[name2] == value2)
}

export function Listfilter_2Condi_And_Not(list, name1, value1, name2, value2) {
  return list.filter(item => item[name1] != value1 || item[name2] != value2)
}

//根据名字和年龄多元素筛选,如list,{name:['Leila', 'Jay'],age:[]},[{name: "Leila", age: 16, gender: "female"},{name: "Jay", age: 19, gender: "male"}]
export function Listfilter_nCondi_And(list, filters) {
  const filterKeys = Object.keys(filters)
  // filters all elements passing the criteria
  return list.filter((item) => {
    // dynamically validate all filter criteria
    return filterKeys.every(key => {
        //ignore when the filter is empty Anne
      if(!filters[key].length) return true
      return !!~filters[key].toString().indexOf(item[key])
    })
  })
}


// WEBPACK FOOTER //
// ./src/api/jsDb/dbms.js